import { OfbizForm, OfbizList } from "@urbannex/ofbiz-forms";
import { ConfigOptions, getColumnFieldTitles, getFields, getIdFieldName, getTarget, getTargets } from "@urbannex/view-containers";
import { ORDR_FORMS } from "./forms";
import { NbMenuItem } from "@nebular/theme";

export const options:ConfigOptions = {
    name: "Order Management System",
    title: "OMS",
    menuAndTitleOptions: {
        path: "order",
        headerTitle: "Order Management System",
        menuItems: [],
        menuTag: "ordersMenu"
    },
    listForm:new OfbizList({
        listType:"grid",
        listFormName:"OrderList",
        listFormLocation:"component://kwikstore/widget/OrderForms.xml",
        columnFields:getFields("OrderList",ORDR_FORMS),
        columnFieldTitles:getColumnFieldTitles("OrderList",ORDR_FORMS),
        idFieldName:getIdFieldName("OrderList",ORDR_FORMS),
        target:getTarget("OrderList",ORDR_FORMS),
        viewIndex:0,
        findParameters:[{"facilityId":"WebStoreWarehouse"},{"viewIndex":0},{"viewSize":20}],
        appContext:"orders",
        remoteFormData:{
            formData:{
                formName:"OrderList",
                formLocation:"component://kwikstore/widget/OrderForms.xml",
                listType:"grid",
            }
        },
        emptyListMessage:"No Orders Found"
    }),
    findForm: new OfbizForm,
    addForm: new OfbizForm(),
    actions: [],
    settings: [],
    masterDetails:[
        {
            title: "Update Order Items",
            listForm: new OfbizList({
                listType: "grid",
                listFormName: "OrderItemsMaster",
                listFormLocation: "component://kwikstore/widget/OrderForms.xml",
                columnFields: getFields("OrderItemsMaster", ORDR_FORMS),
                columnFieldTitles: getColumnFieldTitles("OrderItemsMaster", ORDR_FORMS),
                idFieldName: getIdFieldName("OrderItemsMaster", ORDR_FORMS),
                target: getTarget("OrderItemsMaster", ORDR_FORMS),
                viewIndex: 0,
                findParameters: [],
                appContext: "orders",
                remoteFormData: {
                    formData: {
                        formName: "OrderItemsMaster",
                        formLocation: "component://kwikstore/widget/OrderViewForms.xml",
                        listType: "grid",
                    },
                    parameters: {
                        orderId: ""
                    }
                },
                emptyListMessage: "No Order Items Found"
            }),
            addForm: new OfbizForm({
                title: "Edit Order Item",
                titleDescriptionField: "orderItemSeqId",
                formName: "EditOrderItem",
                formLocation: "component://kwikstore/widget/OrderViewForms.xml",
                local: true,
                layout: "SingleColumn",
                fields: getFields("EditOrderItem", ORDR_FORMS),
                target: getTarget("EditOrderItem", ORDR_FORMS),
                appContext: "orders",
                breadCrumbData:{
                    displayPrefix:"Order Items",
                    addFormText:"Add Order Item",
                    editFormText:"Edit Order Item",
                    data:{
                        formData:{
                            formName:"EditOrderItem",
                            formLocation:"component://kwikstore/widget/OrderViewForms.xml",
                        },
                        endPoint:"updateOrderItem",
                        parameters:{
                            orderId:"",
                            orderItemSeqId:""
                        }
                    }
                }
                
            }),
            addContainerTitle: "Update Order Item",
            listContainerTitle: "List Order Items",
            keyMap: undefined,
            addFormName: "",
            listFormName: ""
        },
        {
            title: "Update Order Adjustments",
            listForm: new OfbizList({
                listType: "grid",
                listFormName: "EditOrderAdjustments",
                listFormLocation: "component://kwikstore/widget/OrderForms.xml",
                columnFields: getFields("EditOrderAdjustments", ORDR_FORMS),
                columnFieldTitles: getColumnFieldTitles("EditOrderAdjustments", ORDR_FORMS),
                idFieldName: getIdFieldName("EditOrderAdjustments", ORDR_FORMS),
                target: getTarget("EditOrderAdjustments", ORDR_FORMS),
                viewIndex: 0,
                findParameters: [{"orderId":""}],
                appContext: "orders",
                remoteFormData: {
                    formData: {
                        formName: "EditOrderAdjustments",
                        formLocation: "component://kwikstore/widget/OrderViewForms.xml",
                        listType: "grid",
                    },
                    parameters: {
                        orderId: ""
                    }
                },
                emptyListMessage: "No Order Headers Found"
            }),
            addContainerTitle: "Update Order Adjustments",
            listContainerTitle: "Order Adjustments",
            keyMap: undefined,
            addFormName: "EditOrderAdjustment",
            listFormName: "EditOrderAdjustments",
            addForm: new OfbizForm({
                title: "Edit Order Header",
                titleDescriptionField: "orderId",
                formName: "EditOrderAdjustment",
                formLocation: "component://kwikstore/widget/OrderViewForms.xml",
                local: true,
                layout: "SingleColumn",
                fields: getFields("EditOrderAdjustment", ORDR_FORMS),
                target: getTarget("EditOrderAdjustment", ORDR_FORMS),
                appContext: "orders",
                breadCrumbData:{
                    displayPrefix:"Order Adjustments",
                    addFormText:"Add Order Adjustments",
                    editFormText:"Edit Order Adjustments",
                    data:{
                        formData:{
                            formName:"EditOrderAdjustment",
                            formLocation:"component://kwikstore/widget/OrderViewForms.xml",
                        },
                        endPoint:"updateOrderAdjustment",
                        parameters:{
                            orderId:"",
                            orderAdjustmentId:""
                        }
                    }
                }
            }),
        },
        {
            title: "Order Payment Preferences",
            listForm: new OfbizList({
                listType: "grid",
                listFormName: "PaymentsListMaster",
                listFormLocation: "component://kwikstore/widget/OrderForms.xml",
                columnFields: getFields("PaymentsListMaster", ORDR_FORMS),
                columnFieldTitles: getColumnFieldTitles("PaymentsListMaster", ORDR_FORMS),
                idFieldName: getIdFieldName("PaymentsListMaster", ORDR_FORMS),
                target: getTarget("PaymentsListMaster", ORDR_FORMS),
                viewIndex: 0,
                findParameters: [],
                appContext: "orders",
                remoteFormData: {
                    formData: {
                        formName: "PaymentsListMaster",
                        formLocation: "component://kwikstore/widget/OrderViewForms.xml",
                        listType: "grid",
                    },
                    parameters: {
                        orderId: ""
                    }
                },
                emptyListMessage: "No Order Payments Found"
            }),
            addContainerTitle: "Update Order Payments",
            listContainerTitle: "Order Payment Preferences",
            keyMap: undefined,
            addFormName: "EditOrderPaymentPreference",
            listFormName: "PaymentsListMaster",
            addForm: new OfbizForm({
                title: "Edit Order Payment Preference",
                titleDescriptionField: "orderId",
                formName: "EditOrderPaymentPreference",
                formLocation: "component://kwikstore/widget/OrderViewForms.xml",
                local: true,
                layout: "SingleColumn",
                fields: getFields("EditOrderPaymentPreference", ORDR_FORMS),
                target: getTarget("EditOrderPaymentPreference", ORDR_FORMS),
                appContext: "orders",
                breadCrumbData:{
                    displayPrefix:"Order Payments",
                    addFormText:"Add Order Payment",
                    editFormText:"Edit Order Payment",
                    data:{
                        formData:{
                            formName:"EditOrderPaymentPreference",
                            formLocation:"component://kwikstore/widget/OrderViewForms.xml",
                        },
                        endPoint:"updateOrderPaymentPreference",
                        parameters:{
                            orderId:"",
                            orderPaymentPreferenceId:""
                        }
                    }
                }
            }),
        },
        {
            title: 'Customer Contact Information',
            dynamic: true,
            dynamicAddForms: [
            new OfbizForm({
                title: "Edit Order Postal Address",
                titleDescriptionField: "orderItemSeqId",
                formName: 'EditOrderPostalAddress',
                formLocation: 'component://kwikstore/widget/OrderViewForms.xml',
                fields: getFields('EditOrderPostalAddress', ORDR_FORMS),
                target: getTarget("EditOrderPostalAddress", ORDR_FORMS),
                breadCrumbData:{
                displayPrefix:"Order Shipping Contact",
                addFormText:"Add Order Item",
                editFormText:"Edit Order Shipping Contact",
                data:{
                    formData:{
                        formName:"EditOrderPostalAddress",
                        formLocation:"component://kwikstore/widget/OrderViewForms.xml",
                    },
                    endPoint:"updatePostalAddress",
                    parameters:{
                        orderId:"",
                        contactMechId:""
                    }
                }
                },
                dynamicFormConditions:{
                field:"contactMechPurposeTypeId",
                value:"Shipping Destination Address",
                operator:"equals"
                }
            }),
            new OfbizForm({
                title: "Edit Order Email Address",
                titleDescriptionField: "orderItemSeqId",
                formName: 'EditOrderEmailAddress',
                formLocation: 'component://kwikstore/widget/OrderViewForms.xml',
                fields: getFields('EditOrderEmailAddress', ORDR_FORMS),
                target: getTarget("EditOrderEmailAddress", ORDR_FORMS),
                breadCrumbData:{
                displayPrefix:"Order Email",
                addFormText:"Add Order Item",
                editFormText:"Edit Order Email Contact",
                data:{
                    formData:{
                        formName:"EditOrderEmailAddress",
                        formLocation:"component://kwikstore/widget/OrderViewForms.xml",
                    },
                    endPoint:"updateEmailAddress",
                    parameters:{
                        orderId:"",
                        contactMechId:""
                    }
                }
                },
                dynamicFormConditions:{
                field:"contactMechPurposeTypeId",
                value:"Order Notification Email Address",
                operator:"equals"
                }
            }),
            ],
            listForm: new OfbizList({ 
            listType: 'grid',
            listFormName: 'ContactMechMasterList',
            listFormLocation: 'component://kwikstore/widget/OrderViewForms.xml',
            columnFields: getFields("ContactMechMasterList", ORDR_FORMS),
            columnFieldTitles: getColumnFieldTitles("ContactMechMasterList", ORDR_FORMS),
            idFieldName: getIdFieldName("ContactMechMasterList", ORDR_FORMS),
            target: '',
            viewIndex: 0,
            findParameters: [],
            appContext: 'orders',
            remoteFormData: {
                formData: {
                formName: 'ContactMechMasterList',
                formLocation: 'component://kwikstore/widget/OrderViewForms.xml',
                listType: 'grid'
                }
            },
            emptyListMessage: 'No items found' 
            }),
            addContainerTitle: 'Edit Order Contact ${contactMechPurposeTypeId}',
            listContainerTitle: 'Order Contacts',
            keyMap: undefined,
            addFormName: '',
            listFormName: ''
        },
        {
            title: 'Customer Order History',
            addContainerTitle: 'Order Info ${orderId}',
            listContainerTitle: 'Customer Orders',
            isListDetail:true,
            keyMap: undefined,
            addFormName: '',
            listFormName: '',
            listForm: new OfbizList({
                listType: 'grid',
                listFormName: 'PartyOrders',
                listFormLocation: 'component://kwikstore/widget/OrderViewForms.xml',
                columnFields: getFields("PartyOrders", ORDR_FORMS),
                columnFieldTitles: getColumnFieldTitles("PartyOrders", ORDR_FORMS),
                idFieldName: getIdFieldName("PartyOrders", ORDR_FORMS),
                target: '',
                viewIndex: 0,
                findParameters: [],
                appContext: 'orders',
                remoteFormData: {
                formData: {
                    formName: 'PartyOrders',
                    formLocation: 'component://kwikstore/widget/OrderForms.xml',
                    listType: 'grid'
                }
                },
                emptyListMessage: 'No orders found'
            }),
            listDetail: new OfbizList({
                listType: 'grid',
                listFormName: 'OrderItems',
                listFormLocation: 'component://kwikstore/widget/OrderViewForms.xml',
                columnFields: getFields("OrderItems", ORDR_FORMS),
                columnFieldTitles: getColumnFieldTitles("OrderItems", ORDR_FORMS),
                idFieldName: getIdFieldName("OrderItems", ORDR_FORMS),
                target: 'orderview',
                viewIndex: 0,
                findParameters: [],
                appContext: 'orders',
                remoteFormData: {
                formData: {
                    formName: 'OrderItems',
                    formLocation: 'component://kwikstore/widget/OrderViewForms.xml',
                    listType: 'grid'
                }
                },
                emptyListMessage: 'No orders found'
            })
        },
        {
            title:"Ship Group Items",
            addContainerTitle: "",
            listContainerTitle: "Ship Groups",
            detailListContainerTitle:"Order Items for ship group",
            keyMap: undefined,
            addFormName: "",
            isListDetail:true,
            listFormName: "",
            listForm:new OfbizList({
                listFormName:"ShipGroupsMaster",
                listFormLocation:"component://kwikstore/widget/OrderViewForms.xml",
                listType:"grid",
                findParameters:[],
                columnFields:getFields("ShipGroupsMaster",ORDR_FORMS),
                columnFieldTitles:getColumnFieldTitles("ShipGroupsMaster",ORDR_FORMS),
                remoteFormData:{
                    formData: {
                        formName: "ShipGroupsMaster",
                        formLocation: "component://kwikstore/widget/OrderViewForms.xml",
                        listType: "grid",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: "No items found"
            }),
            listDetail:new OfbizList({

                listFormName:"OrderItemShipGroupAssociations",
                listFormLocation:"component://kwikstore/widget/OrderViewForms.xml",
                listType:"grid",
                findParameters:[{orderId:""},{shipGroupSeqId:""}],
                columnFields:getFields("OrderItemShipGroupAssociations",ORDR_FORMS),
                columnFieldTitles:getColumnFieldTitles("OrderItemShipGroupAssociations",ORDR_FORMS),
                remoteFormData:{
                    formData: {
                        formName: "OrderItemShipGroupAssociations",
                        formLocation: "component://kwikstore/widget/OrderViewForms.xml",
                        listType: "grid",
                        viewIndex: 0,
                        viewSize: 0
                    }
                },
                emptyListMessage: "No items found"
            }),
        }
    ],
    relations: [
        {
            title: "Update Order Items",
            listForm: new OfbizList({
                listType: "grid",
                listFormName: "OrderItemsMaster",
                listFormLocation: "component://kwikstore/widget/OrderForms.xml",
                columnFields: getFields("OrderItemsMaster", ORDR_FORMS),
                columnFieldTitles: getColumnFieldTitles("OrderItemsMaster", ORDR_FORMS),
                idFieldName: getIdFieldName("OrderItemsMaster", ORDR_FORMS),
                target: getTarget("OrderItemsMaster", ORDR_FORMS),
                viewIndex: 0,
                findParameters: [{ "facilityId": "WebStoreWarehouse" }, { "viewIndex": 0 }, { "viewSize": 20 }],
                appContext: "orders",
                remoteFormData: {
                    formData: {
                        formName: "OrderItemsMaster",
                        formLocation: "component://kwikstore/widget/OrderViewForms.xml",
                        listType: "grid",
                    }
                },
                emptyListMessage: "No Order Items Found"
            }),
            addForm: undefined,
            addContainerTitle: "",
            listContainerTitle: "",
            keyMap: undefined,
            addFormName: "",
            listFormName: ""
        },
        {
            title:"Order Delivery Schedule",
            addContainerTitle: "Schedule Order Delivery",
            listContainerTitle: "",
            keyMap: undefined,
            addFormName: "",
            listFormName: "",
            addForm:new OfbizForm({
                title:"Order Delivery Schedule",
                formName:"UpdateDeliveryScheduleInformation",
                formLocation:"component://kwikstore/widget/OrderForms.xml",
                fields:getFields("UpdateDeliveryScheduleInformation",ORDR_FORMS),
                target:getTarget("UpdateDeliveryScheduleInformation",ORDR_FORMS),
                targets:getTargets("UpdateDeliveryScheduleInformation",ORDR_FORMS),
                idFieldName:"orderId",
                id:"orderId",
                appContext: "orders",
                breadCrumbData:{
                    displayPrefix:"Schedule Order Delivery",
                    addFormText:"Add Schedule Order Delivery",
                    editFormText:"Edit Schedule Order Delivery",
                    data:{
                        formData:{
                            formName:"UpdateDeliveryScheduleInformation",
                            formLocation:"component://kwikstore/widget/OrderForms.xml",
                        },
                        endPoint:"updateOrderDeliverySchedule",
                        parameters:{
                            orderId:"",
                        }
                    }
                }
            }),
        }
    ],
    breadCrumbData:{
        displayPrefix:"Product Feature Categories",
        addFormText:"Create Feature Category",
        editFormText:"Update Feature Category"
    }
}
export const baseMenuItems:NbMenuItem[] = [
    {title:"Orders",group:true},
    {
        title:"Sales",
        children:[
            {title:"List Orders",icon:"list-outline",link:"/admin/orders/sales"},
            {title:"New Sales Order",icon:"plus-outline"},
        ]
    },
    {
        title:"Purchases",
        children:[
            {title:"List Orders",icon:"list-outline",link:"/admin/orders/purchases"},
            {title:"New Purchase Order",icon:"plus-outline"},
        ]
    }
]